module.exports = __webpack_public_path__ + "static/img/byconcept-01.cffcf54.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-01.webp
// module id = 67
// module chunks = 0